import { PageHero } from "@/components/sections/PageHero";
import { CTABand } from "@/components/sections/CTABand";
import { FAQS, IMAGES } from "@/lib/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHero
        eyebrow="FAQ"
        title={<>Straight <span className="text-[#FF5722]">answers.</span></>}
        subtitle="The questions we hear most from fabricators, contractors, engineers, and purchasing managers."
        image={IMAGES.powder2}
      />

      <section className="section px-6 lg:px-10">
        <div className="max-w-4xl">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display text-xl md:text-2xl tracking-tight py-6 hover:no-underline hover:text-[#FF5722] transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-300 leading-relaxed pb-6 text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
